export class FormatHandler {
    public static formatIban(iban?: string) {
        if (iban) {
            return iban.toUpperCase().replaceAll(' ', '')
        }

        return iban;
    }

    public static removeEmptyStrings(obj: any): any {

        if (typeof obj !== 'object') {
            return obj;
        }

        for (const prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                if (obj[prop] === '') {
                    delete obj[prop];
                } else if (typeof obj[prop] === 'object') {
                    FormatHandler.removeEmptyStrings(obj[prop]);
                    if (FormatHandler.isEmpty(obj[prop])) {
                        delete obj[prop];
                        continue;
                    }
                    if (Object.keys(obj[prop]).length === 0 && obj[prop].constructor === Object) {
                        delete obj[prop];
                    }
                }
            }
        }

        return obj;
    }

    public static isEmpty(obj: any) {
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== null && obj[key] !== '' && typeof obj[key] !== 'undefined') {
                return false;
            }
        }
        return true;
    }
}